<div class="vehicle-type">
    <span>{{vehicleType?.name}}</span>
</div>